export enum DatasetKeys {
  UiAction = 'data-ui-action',
  UiYmEvent = 'data-ui-ym-event',
  UiTmrEvent = 'data-ui-tmr-event',
  FormId = 'data-form-id',
  TestId = 'data-testid',
}

export const DatasetActionValues = {
  renderForm: 'render-form',
  signIn: 'sign-in',
  signUp: 'sign-up',
  signOut: 'sign-out',
  appLink: 'app-link',
} as const;

export type DatasetActionValues =
  (typeof DatasetActionValues)[keyof typeof DatasetActionValues];

export type Dataset = Partial<{
  [DatasetKeys.UiAction]: DatasetActionValues;
  [DatasetKeys.UiYmEvent]: string;
  [DatasetKeys.UiTmrEvent]: string;
  [DatasetKeys.FormId]: string;
  [DatasetKeys.TestId]: string;
}>;
